// src/routes/dashboard.routes.tsx
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/dashboard';
import DashboardHome from '../pages/dashboard/DashboardHome';
import Wallets from '../pages/dashboard/Wallets';
import WalletDetail from '../pages/dashboard/WalletDetail';
import USDWalletDetail from '../pages/dashboard/USDWalletDetail';
import Transfers from '../pages/dashboard/Transfers';
import Cards from '../pages/dashboard/Cards';
import CardDetail from '../pages/dashboard/CardDetail';
import Transactions from '../pages/dashboard/Transactions';
import Swap from '../pages/dashboard/Swap';
import Counterparties from '../pages/dashboard/Counterparties';
// import CreateCounterparties from "../pages/dashboard/counterparties/create";
// import CounterpartyDetails from "../pages/dashboard/counterparties/counterpartydetails";
// import CustomerDetails from "../pages/dashboard/counterparties/customerdetails";
import Setting from "../pages/user/Setting"
import ReferralProgram from "../pages/dashboard/ReferralProgram";
import Profile from "../pages/user/Profile"
import Support from "../pages/dashboard/Support";
import SupportTicketDetail from "../pages/dashboard/SupportTicketDetail";
import Investments from "../pages/dashboard/Investments";
import { DashboardLoadingProvider } from '../context/DashboardLoadingContext';
export default function DashboardRoutes() {
  return (
    <DashboardLoadingProvider>
      <Routes>
        <Route element={<Dashboard />}>
          <Route index element={<DashboardHome />} />
          <Route path="wallets" element={<Wallets />} />
          <Route path="wallets/usd" element={<USDWalletDetail />} />
          <Route path="wallets/:token/:address" element={<WalletDetail />} />
          <Route path="counterparties" element={<Counterparties />} />
          {/* <Route path="counterparties/create" element={<CreateCounterparties />} />
          <Route path="counterparties/:counterpartyId" element={<CounterpartyDetails />} />
          <Route path="counterparties/customerdetails" element={<CustomerDetails />} /> */}
          <Route path="cards" element={<Cards />} />
          <Route path="cards/:cardId" element={<CardDetail />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="swap" element={<Swap />} />
          <Route path="investments" element={<Investments />} />
          <Route path="transfers" element={<Transfers />} />
          <Route path="settings" element={<Setting />} />
          <Route path="myprofile" element={<Profile />} />
          <Route path="referral" element={<ReferralProgram />} />
          <Route path="support" element={<Support />} />
          <Route path="support/:ticketId" element={<SupportTicketDetail />} />
        </Route>
      </Routes>
    </DashboardLoadingProvider>
  );
}